import {
  FETCH_AGENTI_START,
  FETCH_AGENTI_SUCCESS,
  FETCH_AGENTI_FAILURE,
  SAVE_AGENTE_START,
  SAVE_AGENTE_SUCCESS,
  SAVE_AGENTE_FAILURE,
  DELETE_AGENTE_START,
  DELETE_AGENTE_SUCCESS,
  DELETE_AGENTE_FAILURE,
} from '../actions/Agenti';

const initialState = {
  agenti: [],
  loading: false,
  error: null,
};

export default function agentiReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_AGENTI_START:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_AGENTI_SUCCESS:
      return {
        ...state,
        loading: false,
        agenti: action.payload,
        error: null,
      };

    case FETCH_AGENTI_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SAVE_AGENTE_START:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case SAVE_AGENTE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case SAVE_AGENTE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_AGENTE_START:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case DELETE_AGENTE_SUCCESS:
      return {
        ...state,
        loading: false,
        agenti: state.agenti.filter(a => a.id !== action.payload),
        error: null,
      };

    case DELETE_AGENTE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
}
